import ConfirmQueryChange from './ConfirmQueryChange';

export default ConfirmQueryChange;
